import React, { Component } from 'react'
import './ccs-event-management.css'
import { FormButton, FormButtonContent } from '@myxplor/forms'
import { ContentToggleIcon } from '@myxplor/icons'
import { JSONTreeWrapped } from '../../../../ui/json-tree'
class EventRow extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.state = {
      detailsOpen: false,
    }
  }

  toggle() {
    this.setState({
      detailsOpen: !this.state.detailsOpen,
    })
  }

  render() {
    const {
      event: { event_id, start_date, end_date, event_description, event_gov_record },
    } = this.props

    const { detailsOpen } = this.state

    return (
      <div className="event-row">
        <div className="event-item gov_id">{event_id}</div>
        <div className="event-item startDate">{start_date}</div>
        <div className="event-item endDate">
          {end_date}
        </div>
        <div className="event-item description">
          {event_description}
        </div>
        <div className="event-item details">
          <FormButton right className="eventsDetail--toggle" onClick={this.toggle}>
            <ContentToggleIcon right open={detailsOpen} />
            <FormButtonContent>{`${detailsOpen ? 'Hide' : 'View'} details`}</FormButtonContent>
          </FormButton>
        </div>
        <div className="event-detail">
          {detailsOpen ? <JSONTreeWrapped data={event_gov_record} /> : null}
        </div>
      </div>
    )
  }
}

export default EventRow



// WEBPACK FOOTER //
// ./src/gov-registrations/details/events-management/views/event-row.jsx